import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth/AuthProvider";
import { setTokenGetter } from "./api/client";
import { Layout } from "./components/Layout";
import { Login } from "./pages/Login";
import { DocumentUpload } from "./pages/DocumentUpload";
import { SessionList } from "./pages/SessionList";
import { SessionDetail } from "./pages/SessionDetail";
import { Providers } from "./pages/Providers";
import { ProviderDetail } from "./pages/ProviderDetail";

function AdminRoute({ children }: { children: React.ReactNode }) {
  const { isAdmin } = useAuth();
  if (!isAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
}

function ProtectedRoutes() {
  const { isAuthenticated, isLoading, token } = useAuth();

  useEffect(() => {
    if (token) setTokenGetter(() => token);
  }, [token]);

  if (isLoading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<DocumentUpload />} />
        <Route path="upload" element={<DocumentUpload />} />
        <Route path="sessions" element={<SessionList />} />
        <Route path="sessions/:id" element={<SessionDetail />} />
        <Route path="providers" element={<AdminRoute><Providers /></AdminRoute>} />
        <Route path="providers/:id" element={<AdminRoute><ProviderDetail /></AdminRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={<ProtectedRoutes />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
